import type { Category } from './categories'

interface Cta {
  buttonText: string
  launchButtonText: string
  launchButtonDescription: string
  imageUrl: string
}

export const ctas: Record<Category, Cta> = {
  laptops: {
    buttonText: 'Need help finding your Laptop?',
    launchButtonText: 'Choose your laptop with confidence',
    launchButtonDescription:
      "Answer some questions about what you want, and we'll shortlist the best matches from hundreds of lab tested laptops",
    imageUrl:
      'https://media.which.gpp.io/prod/images/ar_1to1_300x300/8ef0839eb732-db4d537c7c1525a2a3ff022c077244969ff174fa.webp',
  },
  mattresses: {
    buttonText: 'Don’t guess with your health. Get a personal recommendation',
    launchButtonText: 'Don’t guess with your health. Get a personal recommendation',
    launchButtonDescription:
      'Answer some questions about what you need, and we’ll shortlist the best matches from hundreds of lab tested mattresses',
    imageUrl:
      'https://media.which.gpp.io/prod/images/ar_1to1_300x300/a792b44ec936-e7bc998ee651f3baedf64ed110b395745331318d.webp',
  },
}
